import styled, { css } from 'styled-components';
import { palette } from '../../../theme/colors';
import { toRem } from '../../../utils/toRem';

export const SMapWrapper = styled.div`
  position: relative;
  padding: 0 ${toRem(10)};
`;

export const STime = styled.div`
  position: absolute;
  bottom: 0.5rem;
  right: 0.75rem;
  background-color: ${palette.background};
  height: ${toRem(18)};
  width: ${toRem(38)};
  border-radius: ${toRem(18)};
  font-size: ${toRem(10)};
  font-family: 'Roboto-Medium';
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SAlertContainer = styled.div<{ isSent: boolean }>`
  ${props =>
    !props.isSent &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}

  margin-left: 0.75rem;
`;

export const SAlertMessageInfoContainer = styled.div`
  font-size: 0.75rem;
  line-height: ${toRem(15.3)};
  font-family: 'Roboto-Regular';
  font-weight: 500;
  overflow-wrap: break-word;
  .alertDetailsMessageContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 0.75rem;
  }

  .alertIconContainer {
    margin-right: 0.5rem;
    img {
      max-height: 3rem;
    }
  }

  .emergencyType {
    font-family: 'Roboto-Medium';
    font-size: 1rem;
    line-height: 16px;
    line-height: ${toRem(20.8)};
    color: ${palette.white};
    margin-bottom: ${toRem(2)};
  }

  .organization {
    color: ${palette.navy20};
    flex-shrink: 1;
  }

  .forwardedAlarmOrganization {
    color: ${palette.navy20};
    font-style: normal;
  }
  .text-container {
    max-width: 100%;
    padding-right: 1rem;
    overflow-x: hidden;
  }
`;

export const SNoMapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  place-content: center;

  div {
    position: absolute;
    z-index: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
  }

  img {
    width: 100%;
    height: 100%;
    filter: blur(2px);
    object-fit: cover;
    opacity: 0.5;
  }

  p {
    margin: 0.75rem auto 0;
    text-align: center;
    width: 80%;
  }
`;

export const SPrewrittenTextWrapper = styled.div`
  padding: ${toRem(6)} 0.75rem 0.75rem;
`;

export const SPrewrittenTextTitleText = styled.p`
  font-size: 0.75rem;
  font-family: 'Roboto-Medium';
  line-height: 1rem;
  color: ${palette.qingYellow};
  margin-bottom: 0.125rem;
  overflow-wrap: break-word;
`;

export const SAlarmText = styled.p`
  font-family: 'Roboto-Regular';
  font-size: 1rem;
  line-height: 1.3rem;
  color: ${palette.white};
  white-space: pre-wrap;
  padding-right: 0.5rem;
  flex: 1;
  overflow-wrap: break-word;
`;

export const SCustomTextWrapperTime = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: ${toRem(11)};
  color: ${palette.navy20};
  font-weight: 500;
  font-family: 'Roboto-Regular';
  margin: ${toRem(-12)} 0.5rem ${toRem(6)};
`;

export const SLocationWrapper = styled.div`
  display: flex;
  font-family: 'Roboto-Regular';
  padding: 0.5rem ${toRem(10)} 0.25rem;
  gap: 0.25rem;
  font-size: ${toRem(12)};
  line-height: ${toRem(15.3)};

  .mapMarker {
    height: ${toRem(14)};
  }
  .location,
  .forwardedAlarmLocation {
    color: ${palette.navy20};
    flex-shrink: 1;
  }
`;
